import React from "react";
import DOMPurify from "dompurify";

// Tiny markdown renderer (headings, bold, lists, paragraphs). Output is
// sanitised with DOMPurify to prevent XSS from user- or AI-generated content.
const PURIFY_OPTS = {
  ALLOWED_TAGS: ["strong", "em", "code"],
  ALLOWED_ATTR: [],
};
const clean = (s) => DOMPurify.sanitize(s, PURIFY_OPTS);

const inline = (s) => {
  const rendered = s
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.+?)\*/g, "<em>$1</em>")
    .replace(/`([^`]+)`/g, "<code>$1</code>");
  return clean(rendered);
};

export default function Markdown({ text }) {
  if (!text) return null;
  const lines = text.split("\n");
  const out = [];
  let listBuf = [];
  const flushList = () => {
    if (listBuf.length) {
      out.push(
        <ul key={`ul-${out.length}`}>
          {listBuf.map((l, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: inline(l) }} />
          ))}
        </ul>
      );
      listBuf = [];
    }
  };

  lines.forEach((raw, i) => {
    const l = raw.trim();
    if (!l) { flushList(); return; }
    if (l.startsWith("### ")) { flushList(); out.push(<h3 key={i}>{l.slice(4)}</h3>); return; }
    if (l.startsWith("## ")) { flushList(); out.push(<h2 key={i}>{l.slice(3)}</h2>); return; }
    if (l.startsWith("# ")) { flushList(); out.push(<h1 key={i}>{l.slice(2)}</h1>); return; }
    if (l.startsWith("- ") || l.startsWith("* ")) { listBuf.push(l.slice(2)); return; }
    flushList();
    out.push(<p key={i} dangerouslySetInnerHTML={{ __html: inline(l) }} />);
  });
  flushList();
  return <div className="prose-veda">{out}</div>;
}
